import { formatNumber } from 'ui';

import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';

export const MaterialSampleBreakdownItem = ({
  label,
  value,
  totalWeight,
  precision = 1,
}: {
  label: string;
  value: number;
  totalWeight: number;
  precision?: number;
}) => {
  return (
    <MaterialBreakdownItem
      key={label}
      label={label}
      value={
        value
          ? formatNumber(value, {
              maximumFractionDigits: precision,
              minimumFractionDigits: precision,
              style: 'kilogram',
            })
          : formatNumber(0, {
              minimumFractionDigits: 0,
              style: 'kilogram',
            })
      }
      secondaryValue={
        value
          ? formatNumber((value / totalWeight) * 100, {
              style: 'percent',
            })
          : '-'
      }
    />
  );
};
